import React from 'react';
import { useQueryString } from '../../../../hooks/use_query_string';
import { RoutePaths } from '../../../../routes';
import { ContentWrapper } from '../../../content_wrapper/content_wrapper';
import { OmniaLinkButton } from '../../../omnia_button/omnia_link_button';
import { SearchQueryParams } from '../../../search_universal/search_universal';
import SvgSearch from '../../../svg/search';
import styles from './search_hero.less';

export const SearchHero = () => {
  const { replaceQueryString } = useQueryString();

  return (
    <section className={styles.hero}>
      <section className={styles.bg}>
        <ContentWrapper>
          <div className={styles.top}>
            <h1 className={styles.h1}>Hit the Water with the Perfect Plan and Tackle</h1>
            <div
              className={styles.waterbodySelectWrapper}
              onClick={() => {
                replaceQueryString({
                  [SearchQueryParams.search_open]: true,
                  [SearchQueryParams.search_modal_open]: true,
                });
              }}
            >
              <div className="flex items-center justify-between bg-white rounded-[10px] overflow-hidden cursor-pointer">
                <div className="h-[54px] px-6 text-base sm:text-lg text-[#06162298] flex items-center">
                  Search Products & Lakes
                </div>
                <div className="h-[54px] px-4 bg-[#e84b25] flex items-center justify-center">
                  <SvgSearch width={24} height={24} />
                </div>
              </div>
            </div>
            <span className={styles.bottomLine}>
              {' '}
              or
              <OmniaLinkButton to={RoutePaths.MAP} kind="text" size="lg">
                Explore Nearby Lakes
              </OmniaLinkButton>
            </span>
          </div>
        </ContentWrapper>
      </section>
    </section>
  );
};
